import React from 'react';
import * as ContextTitle from '../../../constants/K007/ContextSortTitle';

/**
 * ContextMenuSort
 */
class ContextMenuSort extends React.Component {

  render() {
    const contextTitleArea = [];
    for (let i = 0; i < ContextTitle.CONTEXT_SORT_TITLE.length; i++) {
      const contextid = 'context_sort_' + i;
      contextTitleArea.push(
        <li className="section_context context_menu_sort" key={i}>
          <a className="context_menu_a" id={contextid} href="javascript:void(0);" >{ContextTitle.CONTEXT_SORT_TITLE[i].name}</a>
        </li>
      );
    }

    return (
      <div id="context_menu_sort">
        <ul>
          <li id="context_sort_item_name">ソートに使用する値<hidden id="contextSortColumnKey"></hidden></li>
          {contextTitleArea}
        </ul>
      </div>
    );
  }
}

export default ContextMenuSort;
